import CreateArticleComponent from "components/admin/CreateArticle";

const CreateArticlePage = () => {
  return (
    <div style={{flex: "auto", height: '100vh', overflow: 'scroll'}} className="">
      <CreateArticleComponent />
    </div>
  );
};

export default CreateArticlePage;
